// utils/datetime.js

const APP_TIME_ZONE = process.env.REACT_APP_TIME_ZONE || "Asia/Jakarta";

function getZonedParts(date, timeZone = APP_TIME_ZONE) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return null;

  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    hourCycle: "h23",
  }).formatToParts(date);

  return Object.fromEntries(parts.map((part) => [part.type, part.value]));
}

function formatZonedDateTime(date, timeZone = APP_TIME_ZONE) {
  const parts = getZonedParts(date, timeZone);
  if (!parts) return "";

  return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}:${parts.second}`;
}

// Format utama ke timezone aplikasi. Default: WIB / Asia/Jakarta.
export function formatDateTime(value) {
  if (!value) return "";

  const s = String(value);

  // MySQL string biasa dianggap sudah tersimpan dalam timezone aplikasi.
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(s)) {
    return s;
  }

  // ISO/UTC atau format lain yang bisa diparse: tampilkan dalam timezone aplikasi.
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return s;

  return formatZonedDateTime(d);
}

// Untuk kirim ke backend: selalu timezone aplikasi, bukan timezone device/browser.
export function nowLocalSql() {
  return formatZonedDateTime(new Date());
}

// Tanggal hari ini di timezone aplikasi.
export function todayLocalISO() {
  const parts = getZonedParts(new Date());
  if (!parts) return "";

  return `${parts.year}-${parts.month}-${parts.day}`;
}
